<template>
    <span class="mr-2">{{ current }}/{{ max }}</span>
    <div class="w-full bg-gray-200 rounded-full" style="height: 15px">
      <div :class="'bg-indigo-600 text-xs leading-none py-1 text-center text-white '+ roundedProgress"
           :style="'width: ' + percentage + '%;height: 15px'"
      >
      </div>
  </div>
</template>
<script>
export default {
  props: {
    current: Number,
    max: Number,
  },
  computed: {
    percentage() {
      return (this.current / this.max) * 100
    },
    roundedProgress() {
      if (this.current != this.max) {
        return 'rounded-l-full'
      } else {
        return 'rounded'
      }
    },
  },
}
</script>
